export default __webpack_public_path__ + "static/media/Purple chip.234f7526.svg";